import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const FACEBOOK_API_ID = publicRuntimeConfig.facebookApiId ?? '';

export default FACEBOOK_API_ID;
